module.exports = __webpack_public_path__ + "media/images/user/favicons/android-chrome-256x256-6a90fd77a2961c456cd21912072583c7.png";